<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("crew", 2) }}</div>
        <div class="section-subTitle my-2">{{ $t("crew_dash_msg") }}</div>
      </div>
      <div>
        <b-button
          v-if="$can('create', 'Crews')"
          variant="default"
          to="add-crew"
          class="btn-blue"
          >{{ $tc("add") }}</b-button
        >
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:300="getCrewsList"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>

        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-if="Crews.length > 0"
        v-for="(item, key) in Crews"
        :key="key"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ $tc(item.crew_title, 1) }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  v-if="$can('update', 'Crews')"
                  @click="goToRoute('/master/edit-crew', item)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item @click="goToRoute('/master/view-crew', item)">
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1"></div>
            <div class="d-flex align-items-end">
              <!-- <label class="ios-switch">
                <input
                  v-model="item.crew_is_active"
                  type="checkbox"
                  class="ios-checkbox"
                  disabled
                />
                <span class="switch-slider"></span>
              </label> -->
              <StatusDot
                :status="item.crew_is_active ? 'active' : 'inactive'"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="Crews.length == 0">
        <p>{{ $t("NoRecords") }}</p>
      </div>
    </div>

    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left" style="width: 120px">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
          <th>
            <img
              v-if="this.columnName != 'crew_title'"
              @click="onSortValue('crew_title', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('crew_title', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('crew_title', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("crew", 1) }}
          </th>
        </tr>
      </thead>
      <tbody v-if="Crews.length > 0">
        <tr v-for="(item, key) in Crews" :key="key">
          <!-- <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="item.crew_is_active ? 'active' : 'inactive'"
              />

              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  v-if="$can('update', 'Crews')"
                  @click="goToRoute('/master/edit-crew', item)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item @click="goToRoute('/master/view-crew', item)">
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td> -->
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="item.crew_is_active ? 'active' : 'inactive'"
              />
              <div
                v-if="$can('update', 'Crews')"
                class="ml-4 clickable-icon"
                @click="goToRoute('/master/edit-crew', item)"
                style="cursor: pointer"
                v-b-tooltip="'Edit'"
                tabindex="0"
              >
                <i class="edit-pen icon blue-icon"></i>
              </div>
              <div
                class="ml-2 clickable-icon"
                @click="goToRoute('/master/view-crew', item)"
                style="cursor: pointer"
                v-b-tooltip="'View'"
                tabindex="0"
              >
                <i class="icon-eye icon blue-icon"></i>
              </div>
            </div>
          </td>
          <td>{{ $tc(item.crew_title, 1) }}</td>
        </tr>
      </tbody>
      <tbody v-if="Crews.length == 0">
        <tr>
          <td colspan="2">
            <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div>
          </td>
        </tr>
      </tbody>
    </table>

    <b-pagination
      v-if="Crews.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Crews from "@/helper/formJSONMaster/Crews";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      gridView: false,
      listView: true,
      Methods: Crews.Methods,
      Crews: [],
      viewingnumbers: [],
      customErrors: {
        message: "",
      },
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",

      debounce: null,
      searchValue: "",
      searchKey: "crew_title",
    };
  },
  beforeMount() {
    this.getCrewsList();
    this.getviewingnumber();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getCrewsList();
      } else {
        this.currentPage = event;
        this.getCrewsList();
      }
    },
    goToRoute: function (path, item) {
      const { crew_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: crew_id,
        },
      });
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getCrewsList();
    },
    getCrewsList: function () {
      this.Crews = [];
      let body = this.getRequestBody("GET", undefined, this.Methods);
      body.url += `?limit=${this.perPage}&currentPage=${this.currentPage}&orderBy=${this.orderby}&columnName=${this.columnName}&searchValue=${this.searchValue}&searchKey=${this.searchKey}`;
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Crews = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/CrewComponents/crew.vue